// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ek-0";